<template>
    <div class='invoice-overview-page-container'>
        <div class='content-container'>
            <div class='invoices-container'>
                <div class='filter-container'>
                    <label>Filtern</label>
                    <DateInput label='Datum' v-model='filter.from'/>
                    <TextInput label='Nummer' v-model='filter.nr'/>
                    <div class='invoices-header'>
                        <label>Nummer</label>
                        <label>Datum</label>
                        <label>Gesamtbetrag</label>
                        <label>Restbetrag</label>
                        <!-- <label>Ausdrucken</label> -->
                    </div>
                </div>
                <div class='invoice' v-for='(invoice, idx) in filteredInvoices' :key='idx'>
                    <div class='entry'>
                        <label class="entry-title">Nummer</label>
                        <label class="entry-value">{{ invoice.invoiceNr }}</label>
                    </div>
                    <div class='entry'>
                        <label class="entry-title">Datum</label>
                        <label class="entry-value">{{ invoice.date }}</label>
                    </div>
                    <div class='entry'>
                        <label class="entry-title">Gesamtbetrag</label>
                        <label class="entry-value">{{  util.formatCurrency(invoice.amount) }}€</label>
                    </div>
                    <div class='entry'>
                        <label class="entry-title">Restbetrag</label>
                        <label class="entry-value">{{  util.formatCurrency(invoice.balance) }}€</label>
                    </div>
                    <!-- <div class='entry'>
                        <button class='print button passive'>
                            <img src='@img/print-solid.svg' />
                        </button>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

import TextInput from '@components/elements/TextInput.vue'
import DateInput from '@components/elements/DateInput.vue'

export default {
    name: 'invoice-overview-page',
    inject: [ 'util', 'globalState' ],
    data() { 
        return {
            filter: {
                from: undefined,
                nr: ''
            },
            invoices: []
        }
    },
    mounted() {
        this.getInvoices()
    },
    computed: {
        customerNr() {
            return this.globalState.customerNr
        },
        filteredInvoices() {
            if (!this.invoices || this.invoices.length < 1) {
                return []
            }

            return this.invoices.filter(invoice => {
                const invoiceDateParts = invoice.date.match(/(\d+)/g);
                const invoiceDate = new Date(invoiceDateParts[2], invoiceDateParts[1]-1, invoiceDateParts[0])

                const nrHit   = !this.filter.nr   || invoice.invoiceNr.toLowerCase().includes(this.filter.nr.toLowerCase())
                const dateHit = !this.filter.from || this.isSameDate(invoiceDate, this.filter.from)

                return nrHit && dateHit
            })
        }
    },
    methods: {
        getInvoices() {
            this.globalState.isLoading = true

            let getInvoiceUrl = this.util.middleware()
            getInvoiceUrl += '/customers/' + this.customerNr
            getInvoiceUrl += '/invoices'

            axios.get(getInvoiceUrl)
            .then(response => {
                this.invoices = response.data
                this.globalState.isLoading = false
            })
            .catch(err => {
                // TODO:
                alert(err)
            })
        },
        isSameDate(dateOne, dateTwo) {
            const sameDay = dateOne.getDate() === dateTwo.getDate()
            const sameMonth = dateOne.getMonth() === dateTwo.getMonth()
            const sameYear = dateOne.getFullYear() === dateTwo.getFullYear()
            return sameDay && sameMonth && sameYear
        }
    },
    components: {
        TextInput,
        DateInput
    }
}
</script>

<style lang='scss' scoped>
.invoice-overview-page-container {
    > .content-container {
        > .invoices-container {
            > .filter-container {
                margin-top: 20px;
                background-color: #fff;
                border-radius: 8px;
                box-shadow: 0 2px 8px #00000022;
                padding: 16px;
                display: flex;
                align-items: center;
                height: fit-content;
                flex-wrap: wrap;

                > label {
                    font-size: 1.5em;
                }

                > .input-wrapper {
                    margin-left: 16px;
                }

                > .invoices-header {
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    margin-top: 24px;

                    > * {
                        flex: 1;
                    }

                    > label {
                        font-size: 1.2em;
                        font-weight: bold;

                        // &:last-of-type {
                        //     text-align: right;
                        // }
                    }

                    @media(max-width: 575px) {
                            display: none;
                        }
                }
            }

            > .invoice {
                margin-top: 20px;
                background-color: #fff;
                border-radius: 8px;
                box-shadow: 0 2px 8px #00000022;
                padding: 16px;
                display: flex;
                flex-wrap: wrap;
                text-align: left;
                border-bottom: 1px solid #ccc;

                > .entry {
                    display: flex;
                    flex: 1;

                    > .entry-title {
                        font-size: 1.2em;
                        font-weight: bold;

                        @media(min-width: 576px) {
                            display: none;
                        }
                    }

                    > button {
                        height: 100%;
                        width: 50px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-left: auto;
                        border-radius: 8px;

                        > img {
                            height: 60%;
                        }
                    }

                    @media(max-width: 575px) {
                        min-width: 100%;
                        padding-top: 4px;
                        justify-content: space-between;
                    }
                }
            }
        }
    }
}
</style>